import AptitudeTestChoice from 'src/entities/AptitudeTestChoice';

export default class FilledAptitudeTestQuestion {
  questionId?: number;
  choice?: AptitudeTestChoice;

  constructor(entity: FilledAptitudeTestQuestion) {
    this.questionId = entity.questionId || undefined;
    this.choice = entity.choice ? new AptitudeTestChoice(entity.choice) : undefined;
  }
}


// WEBPACK FOOTER //
// ./src/entities/FilledAptitudeTestQuestion.tsx